import { Button, Loader, Tooltip, Whisper } from 'rsuite';
import { DEMAND_FORECAST_UPSELL_MESSAGE } from '../../../../../../utils/ipaAccess';
import styles from './DemandForecastCell.module.scss';

type CalculateDemandForecastButtonProps = {
  isLoading: boolean;
  canAccess: boolean;
  onCalculate: () => void;
};

const CalculateDemandForecastButton = ({ isLoading, canAccess, onCalculate }: CalculateDemandForecastButtonProps) => {
  if (isLoading) return <Loader content="Carregando..." />;

  if (!canAccess) {
    return (
      <Whisper trigger="hover" placement="top" speaker={<Tooltip>{DEMAND_FORECAST_UPSELL_MESSAGE}</Tooltip>}>
        <span className={styles.disabledButtonWrapper} data-testid="demand-forecast-locked">
          <Button title="Calcular" appearance="primary" block disabled className={styles.disabledButton}>
            Calcular
          </Button>
        </span>
      </Whisper>
    );
  }

  return (
    <Button title="Calcular" appearance="primary" block onClick={onCalculate}>
      Calcular
    </Button>
  );
};

export default CalculateDemandForecastButton;
